export const state = () => {}
export type RootState = ReturnType<typeof state>
